import { render } from "./FullscreenImage.vue?vue&type=template&id=9298f460&scoped=true"
import script from "./FullscreenImage.vue?vue&type=script&lang=js"
export * from "./FullscreenImage.vue?vue&type=script&lang=js"

import "./FullscreenImage.vue?vue&type=style&index=0&id=9298f460&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9298f460"]])

export default __exports__